var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassStatusDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#E1E2E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.75,
    width: 24.5,
    height: 24.5,
    rx: 12.25,
    fill: "#E1E2E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9558 8.64641L18.8103 9.79178L19.2752 10.2567C19.3559 10.3335 19.4201 10.4259 19.464 10.5283C19.5079 10.6306 19.5305 10.7408 19.5305 10.8522C19.5305 10.9636 19.5079 11.0738 19.464 11.1762C19.4201 11.2785 19.3559 11.3709 19.2752 11.4477L11.619 19.1039H8.89673V16.3817L16.553 8.72548C16.6298 8.6448 16.7221 8.58057 16.8245 8.53669C16.9269 8.4928 17.0371 8.47017 17.1485 8.47017C17.2598 8.47017 17.3701 8.4928 17.4724 8.53669C17.5748 8.58057 17.6672 8.6448 17.7439 8.72548L18.2089 9.19034L19.3543 8.04492L19.9558 8.64641ZM9.74742 18.2533H11.2787L18.6797 10.8522L17.1485 9.32096L9.74742 16.722V18.2533ZM11.0237 12.1224L14.2503 8.89574L14.8518 9.49721L11.6252 12.7239L11.0237 12.1224Z",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassStatusDisable);
export default __webpack_public_path__ + "static/media/class-status-disable.0622c8a42046aaceb792d7d76546fd25.svg";
export { ForwardRef as ReactComponent };